import { useSelector } from 'react-redux';

// The preview iframe uses srcDoc, so relative URLs inside the markup would
// otherwise resolve against the admin app's own origin (releva.ai). Inject a
// <base> pointing at the domain the content belongs to, so links, images and
// nested iframes resolve the way they will on the customer's site.
export const withBaseHref = (html, baseUrl) => {
  if (!baseUrl || /<base[\s>]/i.test(html)) {
    return html;
  }

  let href;
  try {
    href = new URL(baseUrl).href;
  } catch {
    return html;
  }

  const baseTag = `<base href="${href}">`;

  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head[^>]*>/i, (match) => `${match}${baseTag}`);
  }
  if (/<html[^>]*>/i.test(html)) {
    return html.replace(/<html[^>]*>/i, (match) => `${match}<head>${baseTag}</head>`);
  }
  return `${baseTag}${html}`;
};

const PreviewHTML = ({ height = '500px', htmlPreview, baseUrl }) => {
  const domain = useSelector((state) => state.domain?.domain);
  const html = htmlPreview || `<p>Your HTML preview will go here.</p>`;

  return (
    <iframe
      title="Preview"
      className="htmlPreviewBox"
      style={{ overflow: 'auto', height }}
      srcDoc={withBaseHref(html, baseUrl || domain?.url)}
      width="100%"
      // A srcDoc frame with no sandbox runs the markup's scripts on the admin's
      // own origin, where they reach `window.parent`, its storage and its
      // cookies — and an email or a banner is authored content, not ours. The
      // empty value is every restriction: no scripts, an opaque origin, so a
      // link can neither navigate the frame nor open a tab. Markup that has to
      // run belongs in `SdkPreview`, which supplies an SDK to run it against.
      sandbox=""
    />
  );
};

export default PreviewHTML;
